// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2Qhnv","tab":"Tabs_tab__2vmP7","tabActive":"Tabs_tabActive__1yxyU"};